import { HStack, Spinner } from "@chakra-ui/react";

import { Text } from "@equidefi/ui";

import { WorkflowButton } from "@/components/workflow/WorkflowButton";
import { ProcessingFeeSummary } from "@/pages/workflow/payment/ProcessingFeeSummary";
import { StripeWireInstructionsCard } from "@equidefi/portals/components/payment/StripeWireInstructionsCard";

export const StripeWireSection = ({
  investment,
  offering,
  wireInstructions,
  isLoading,
  isContinueLoading,
  onContinue,
}) => {
  if (isLoading) {
    return (
      <HStack spacing={3} py={4}>
        <Spinner size="sm" />
        <Text m="0">Generating wire instructions…</Text>
      </HStack>
    );
  }

  if (!wireInstructions) {
    return (
      <Text textStyle="body2" color="gray.600" mb={4}>
        Wire instructions could not be loaded. Reopen this section or contact support.
      </Text>
    );
  }

  return (
    <>
      <StripeWireInstructionsCard instructions={wireInstructions} investmentId={investment?.id} enablePrint />
      <Text textStyle="body2" color="gray.600" my={4}>
        Click Continue and we'll email these wire instructions to <b>{investment?.user?.email}</b>. Include the
        reference above in your wire memo so we can match the payment to your investment.
      </Text>
      <ProcessingFeeSummary investment={investment} offering={offering} paymentType="customer_balance" />
      <WorkflowButton onClick={onContinue} isLoading={isContinueLoading}>
        Continue
      </WorkflowButton>
    </>
  );
};
